// import homeInfo from '~/store/homeInfo.json';
import constantCreator, { promiseStates } from '~/utils/constantsCreator';
import api from '~/utils/api';
import { isAustralianSite } from '~/utils/region-site-config';

const constant = constantCreator.defineAction('home').defineAction;
const GET_HOME = constant('GET_HOME', promiseStates);
const SET_SEEN_ZONE = constant('SET_SEEN_ZONE');

const LOG_CLICK_QUIZ = constant('LOG_CLICK_QUIZ');
const LOG_CLICK_UPSELL_BOX = constant('LOG_CLICK_UPSELL_BOX');

const initialState = {
  loaded: false,
  isLoading: true,
  homeInfo: [],
  isOpenMobileNavSearch: false,
  destination: '',
  seenZone: {}
  // date: moment().startOf('day').add(1, 'day').toISOString(),
  // isFlexibleDate: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_HOME.PENDING: {
      if (state.loaded) {
        return state;
      }
      return {
        ...state,
        isLoading: true,
        loaded: false,
        homeInfo: [],
      };
    }
    case GET_HOME.RESOLVED: {
      return {
        ...state,
        isLoading: false,
        loaded: true,
        homeInfo: action.data ? action.data.section_ids : [],
      };
    }
    case GET_HOME.REJECTED:
      return {
        ...state,
        isLoading: false,
        loaded: true,
      };
    case SET_SEEN_ZONE:
      return {
        ...state,
        seenZone: { ...state.seenZone, [action.data.name]: action.data.seen }
      };
    default:
      return state;
  }
};

export default reducer;

export const actions = {
  getHome: (date = new Date().toISOString(), country) => ({
    type: GET_HOME,
    promise: api.get(`/experience/home?city=Home${isAustralianSite() ? '-AU' : ''}&date=${date}&country=${country}`),
  }),
  setSeenZone: (name = 'fallback', seen = false) => ({
    type: SET_SEEN_ZONE,
    data: { name, seen }
  }),
  logClickQuiz: path => ({
    type: LOG_CLICK_QUIZ,
    path,
  }),
  logClickUpsellBox: item => ({
    type: LOG_CLICK_UPSELL_BOX,
    item,
  })
};

export const analytics = {
  [LOG_CLICK_QUIZ]: action => ({
    name: 'Click Quiz Topic',
    category: 'Quiz',
    providers: 'database',
    path: action.path,
  }),
  [LOG_CLICK_UPSELL_BOX]: action => ({
    name: 'Click Upsell Box',
    category: 'Home Upsell',
    providers: 'database',
    item: action.item,
  })
};
